"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayout = void 0;
var tslib_1 = require("tslib");
var Layout_1 = require("@reactionable/core/lib/ui/layout/Layout");
var Body_1 = require("./body/Body");
var Footer_1 = require("./footer/Footer");
var Header_1 = require("./header/Header");
function useLayout(props) {
    return Layout_1.useLayout(tslib_1.__assign(tslib_1.__assign({}, props), { HeaderComponent: Header_1.Header, BodyComponent: Body_1.Body, FooterComponent: Footer_1.Footer }));
}
exports.useLayout = useLayout;
//# sourceMappingURL=Layout.js.map